import { BOM_VALIDATION_RESULT_TYPES } from '@/constants'

export const USER_EXPORTS_LIST = {
  id: '63b6cfb911014425daaffb02',
  name: 'Workaround_ETAA',
  creationDate: '2023-01-05T08:08:46',
  creator: 'eu.man.core.engine',
  businessName: 'Workaround ETAA',
  reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
  onDemandExportMetadata: {
    creator: 'c7455',
    exportName: 'Workaround',
    createdAt: '29.09.2022 09:25',
    containsBasicRules: false,
    containsBOM: true,
    conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
    tarStateConfig: 'INWORK'
  },
  encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
}

export const USER_EXPORTS_LIST_BOM = {
  id: '63b6cfb911014425daaffb02',
  name: 'Workaround_ETAA',
  creationDate: '2023-01-05T08:08:46',
  creator: 'eu.man.core.engine',
  businessName: 'Workaround ETAA',
  reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
  onDemandExportMetadata: {
    creator: 'c7455',
    exportName: 'Workaround',
    createdAt: '29.09.2022 09:25',
    containsBasicRules: false,
    containsBOM: true,
    conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
    tarStateConfig: 'INWORK'
  },
  encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
}

export const USER_EXPORTS_LIST_BASIC = {
  id: '63b6cfb911014425daaffb02',
  name: 'Workaround_ETAA',
  creationDate: '2023-01-05T08:08:46',
  creator: 'eu.man.core.engine',
  businessName: 'Workaround ETAA',
  reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
  onDemandExportMetadata: {
    creator: 'c7455',
    exportName: 'Workaround',
    createdAt: '29.09.2022 09:25',
    containsBasicRules: false,
    containsBOM: false,
    conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
    tarStateConfig: 'INWORK'
  },
  encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
}

export const TEST_CASES_FILE_MOCK = {
  id: '635929f4343a6715bb4437fa',
  name: 'testCasetestCase 3',
  creator: 'ab507',
  createdDate: '2022-10-26T12:37:08.107'
}

export const ON_DEMAND_EXPORTS_DEFAULT_STATE = {
  userExports: {
    results: [],
    isInProgress: true,
    size: 0,
    selectedUserExport: {
      id: '63b6cfb911014425daaffe08',
      name: 'Workaround_ETAA',
      creationDate: '2023-01-05T08:08:46',
      creator: 'eu.man.core.test',
      businessName: 'Workaround ETAA',
      reference: 'UserExportMock_XMLRegelwerkKonverterQueue__20220929-160000.json',
      onDemandExportMetadata: {
        creator: 'c7455',
        exportName: 'Workaround',
        createdAt: '29.09.2022 09:25',
        containsBasicRules: false,
        containsBOM: true,
        conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
        tarStateConfig: 'INWORK'
      },
      encodedBusinessName: 'V29ya2Fyb3VuZCBFFCRE'
    },
    selectedUserExportType: 'BOM'
  },
  validations: {
    results: [],
    isInProgress: true,
    size: 0,
    selectedUserExport: {}
  },
  validation: {
    results: [],
    isInProgress: true,
    size: 0
  },
  selectedUserExportType: 'BOM'
}

export const USER_EXPORTS = [
  {
    id: '63b6cfb911014425daaffb01',
    name: 'Workaround_ETAA',
    creationDate: '2023-01-05T08:08:46',
    creator: 'eu.man.core.engine',
    businessName: 'Workaround ETAA',
    reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
    onDemandExportMetadata: {
      creator: 'c7455',
      exportName: 'Workaround',
      createdAt: '29.09.2022 09:25',
      containsBasicRules: false,
      containsBOM: true,
      conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
      tarStateConfig: 'INWORK'
    },
    encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
  },
  {
    id: '63b6cfb911014425daaffb02',
    name: 'Workaround_ETAA',
    creationDate: '2023-01-05T08:08:46',
    creator: 'eu.man.core.engine',
    businessName: 'Workaround ETAA',
    reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
    onDemandExportMetadata: {
      creator: 'c74599',
      exportName: 'Workaround',
      createdAt: '17.05.2020 15:25',
      containsBasicRules: false,
      containsBOM: true,
      conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
      tarStateConfig: 'DONE'
    },
    encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
  },
  {
    id: '63b6cfb911014425daaffbe5',
    name: 'Workaround_ETAA',
    creationDate: '2023-01-05T08:08:46',
    creator: 'eu.man.core.engine',
    businessName: 'Workaround ETAA',
    reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
    onDemandExportMetadata: {
      creator: 'c74599',
      exportName: 'Workaround',
      createdAt: '17.05.2020 15:25',
      containsBasicRules: false,
      containsBOM: false,
      conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
      tarStateConfig: 'DONE'
    },
    encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
  }
]

export const USER_EXPORT_BOM_VALIDATIONS = [
  {
    componentId: '005L',
    encodedBusinessName: 'QXJiZWl0c3N0YW5kIEVudHdpY2tsdW5n',
    checkRange: {
      from: 'PP202101',
      to: 'PP202102'
    },
    user: 'e2e_user',
    status: 'SUCCESS',
    componentOId: 'wt.part.WTPart:8463079011',
    productModelId: '63bee9ba2b2f4959563e5e34',
    id: {
      timestamp: 1673458981,
      date: '2023-01-11T17:43:01.000+00:00'
    },
    createdDate: '2023-01-11T17:43:01.44',
    endDateTime: '2023-01-11T17:52:13.919',
    leandTValidationEnabled: true
  },
  {
    componentId: '005L',
    encodedBusinessName: 'QXJiZWl0c3N0YW5kIEVudHdpY2tsdW5n',
    checkRange: {
      from: 'PP202101',
      to: 'PP202102'
    },
    user: 'e2e_user',
    status: 'SUCCESS',
    componentOId: 'wt.part.WTPart:8463079011',
    productModelId: '63bee9ba2b2f4959563e5e34',
    id: {
      timestamp: 1673459088,
      date: '2023-01-11T17:44:48.000+00:00'
    },
    createdDate: '2023-01-11T17:44:48.756',
    endDateTime: '2023-01-11T17:54:48.728',
    leandTValidationEnabled: false
  },
  {
    componentId: '005L',
    encodedBusinessName: 'QXJiZWl0c3N0YW5kIEVudHdpY2tsdW5n',
    checkRange: {
      from: '202301',
      to: '202335'
    },
    user: 'af445',
    status: 'FAILED',
    componentOId: 'wt.part.WTPart:8463079011',
    productModelId: '63bee9ba2b2f4959563e5e34',
    id: {
      timestamp: 1673466971,
      date: '2023-01-11T19:56:11.000+00:00'
    },
    createdDate: '2023-01-11T19:56:11.519',
    endDateTime: '2023-01-11T19:56:28.727',
    leandTValidationEnabled: false
  },
  {
    componentId: '005L',
    encodedBusinessName: 'QXJiZWl0c3N0YW5kIEVudHdpY2tsdW5n',
    checkRange: {
      from: 'PP202301',
      to: 'PP202301'
    },
    user: 'af445',
    status: 'SUCCESS',
    componentOId: 'wt.part.WTPart:8463079011',
    productModelId: '63bee9ba2b2f4959563e5e34',
    id: {
      timestamp: 1673466898,
      date: '2023-01-11T19:54:58.000+00:00'
    },
    createdDate: '2023-01-11T19:54:58.216',
    endDateTime: '2023-01-11T19:56:26.9',
    leandTValidationEnabled: false
  },
  {
    componentId: '005L',
    encodedBusinessName: 'QXJiZWl0c3N0YW5kIEVudHdpY2tsdW5n',
    checkRange: {
      from: 'PP202101',
      to: 'PP202102'
    },
    user: 'e2e_user',
    status: 'SUCCESS',
    componentOId: 'wt.part.WTPart:8463079011',
    productModelId: '63bee9ba2b2f4959563e5e34',
    id: {
      timestamp: 1673527373,
      date: '2023-01-12T12:42:53.000+00:00'
    },
    createdDate: '2023-01-12T12:42:53.322',
    endDateTime: '2023-01-12T12:43:25.687',
    leandTValidationEnabled: false
  }
]

export const BOM_VALIDATION_AMBIGUOUS = [
  {
    ambiguous1Id2: '81.#005L-0167',
    ambiguous1Name: 'Harnstoffleitungen und Verlegung Tank',
    ambiguous2Id2: '81.#005L-0000',
    ambiguous2Name: 'ohne Harnstoffleitungen und Verlegung Tank',
    rangeFrom: 'PP202101',
    rangeTo: 'PP202101',
    explanation: '((0P1BI - Abgasschalldämpfer, seitlich, rechts, nach hinten versetzt)'
  },
  {
    ambiguous1Id2: '81.#005L-0167',
    ambiguous1Name: 'Harnstoffleitungen und Verlegung Tank',
    ambiguous2Id2: '81.#005L-0000',
    ambiguous2Name: 'ohne Harnstoffleitungen und Verlegung Tank',
    rangeFrom: 'PP202101',
    rangeTo: 'PP202101',
    explanation: '((0P1BI - Abgasschalldämpfer, seitlich, rechts, nach hinten versetzt) '
  }
]

export const VALIDATION_RESULTS_STATE = {
  validation: {
    results: [],
    totalErrorTypes: {
      componentVariant: [],
      solutionElement: [],
      transformation: []
    },
    selectedValidationType: 'componentVariant',
    isInProgress: true,
    size: 0,
    selectedUserExport: {},
    summaryData: []
  }
}

export const SUMMARY_DATA = [
  { validationId: { key: 'validation id', value: '63bef590a8fe5c16c98e0183' } },
  { productModel: { key: 'product model', value: 'Arbeitsstand Entwicklung' } },
  { validationFinishDate: { key: 'validation finished', value: '01/11/2023 02:44 PM' } }
]

export const FILTER_USER_EXPORT_CREATOR = []
export const FILTER_USER_EXPORT_BOM = [
  {
    id: '63b6cfb911014425daaffb02',
    name: 'Workaround_ETAA',
    creationDate: '2023-01-05T08:08:46',
    creator: 'eu.man.core.engine',
    businessName: 'Workaround ETAA',
    reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json',
    onDemandExportMetadata: {
      creator: 'c74599',
      exportName: 'Workaround',
      createdAt: '17.05.2020 15:25',
      containsBasicRules: false,
      containsBOM: true,
      conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
      tarStateConfig: 'DONE'
    },
    encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB'
  }
]
export const FILTER_USER_EXPORT_BASIC = [
  {
    businessName: 'Workaround ETAA',
    creationDate: '2023-01-05T08:08:46',
    creator: 'eu.man.core.engine',
    encodedBusinessName: 'V29ya2Fyb3VuZCBFVEFB',
    id: '63b6cfb911014425daaffbe5',
    name: 'Workaround_ETAA',
    onDemandExportMetadata: {
      conditionalRulesConfig: 'RELEASED_FOR_PROTOTYPE',
      containsBOM: false,
      containsBasicRules: false,
      createdAt: '17.05.2020 15:25',
      creator: 'c74599',
      exportName: 'Workaround',
      tarStateConfig: 'DONE'
    },
    reference: 'UserExport_XMLRegelwerkKonverterQueue__20220929-160000.json'
  }
]

export const INITIAL_STATE_RULE_VAL = {
  userExports: {
    resultsTypes: [],
    resultsType: [],
    results: [],
    filteredResults: [],
    isInProgress: true,
    size: 0,
    selectedUserExport: {},
    selectedUserExportType: '',
    filters: []
  },
  validations: {
    results: [],
    isInProgress: true,
    size: 0,
    selectedUserExport: {}
  },
  validation: {
    results: [],
    totalErrorTypes: {
      componentVariant: [],
      solutionElement: [],
      transformation: []
    },
    selectedValidationType: BOM_VALIDATION_RESULT_TYPES.COMPONENT_VARIANT.key,
    isInProgress: true,
    size: 0,
    selectedUserExport: {},
    summaryData: []
  },
  testCasesFiles: [],
  selectedUserExportType: ''
}
